export const coreTextLimits = {
  workspaceName: 60,
  workspaceDisplayName: 60,
  workspaceDescription: 500,
  branchName: 40,
  branchDescription: 500,
  branchCode: 3,
  groupName: 60,
  groupDescription: 500,
  ministryName: 60,
  ministryDescription: 500,
  offeringTypeName: 60,
  offeringTypeDescription: 500,
  financeAccountName: 80,
  financeCategoryName: 60,
  financeDescription: 500,
  accountHolderName: 160,
  accountNumber: 120,
  activityTitle: 100,
  // Rich-text (HTML) field — generous so headings/lists + markup overhead fit, not just visible text.
  activityDescription: 8000,
  programTitle: 160,
  programDescription: 600,
  budgetTitle: 200,
  // Rich-text (HTML) field — generous so headings/lists + markup overhead fit, not just visible text.
  budgetDescription: 8000,
  budgetLineTitle: 200,
  assetName: 100,
  assetCategoryName: 60,
  supportBugTitle: 100,
  supportBugDescription: 2000,
  memberName: 120,
} as const;

export type CoreTextLimitKey = keyof typeof coreTextLimits;
